import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';
import { getFontScale } from 'themes/mixins/getFontScale';

const Section = styled.section`
  display: grid;
  grid-template-columns: 10rem 1fr;
  column-gap: 1.6rem;
  align-items: flex-start;
  width: 100%;

  padding: 1.2rem 0;

  border-bottom: 0.1rem solid ${pickColor('borderLight')};

  background-color: ${pickColor('white')};
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

const HeaderRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 16rem 12rem 12rem;
  align-items: flex-start;
  column-gap: 1.6rem;

  padding: 0 0 0.6rem;
`;

const ImageCell = styled.div`
  width: 10rem;
  height: 10rem;

  flex-shrink: 0;
  overflow: hidden;
  margin-top: 2rem;
`;

const InfoCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;

  padding-top: 0.2rem;
`;

const TitleLine = styled.div`
  ${getFontScale('xs')};
  font-family: 'LFT Zeno', sans-serif;
  text-transform: uppercase;
  color: ${pickColor('black')};
  letter-spacing: 0.02rem;
`;

const SubtitleLine = styled.div`
  ${getFontScale('xs')};
  font-family: 'LFT Zeno', sans-serif;
  font-weight: bold;
  color: ${pickColor('black')};
`;

const DeliveryCell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.2rem;

  padding-top: 0.2rem;
`;

const DeliveryLabel = styled.span`
  ${getFontScale('xs')};
  color: ${pickColor('grayDark')};
`;

const DeliveryInputWrapper = styled.div`
  width: 8rem;
`;

const DeliveryInput = styled.input`
  width: 100%;
  padding: 0.3rem 0.6rem;

  text-align: right;

  ${getFontScale('xs')};
  font-weight: bold;
  color: ${pickColor('black')};

  border: 0.1rem solid ${pickColor('borderColorDark')};
  background-color: ${pickColor('white')};

  &:disabled {
    background-color: ${pickColor('gray')};
    cursor: not-allowed;
  }

  &:focus {
    outline: none;
    border-color: ${pickColor('colmarBlue')};
  }
`;

const PriceCell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.2rem;

  padding-top: 0.2rem;
`;

const PriceLabel = styled.span`
  ${getFontScale('xs')};
  color: ${pickColor('grayDark')};
  text-transform: capitalize;
`;

const PriceValue = styled.span`
  ${getFontScale('xs')};
  font-weight: bold;
  color: ${pickColor('black')};
`;

const ColoursContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyleTotalsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 16rem 12rem 12rem;
  align-items: center;
  column-gap: 1.6rem;

  padding: 0.4rem 0 0;
`;

const StyleTotalsRemoveCell = styled.button`
  width: auto;
  height: auto;
  max-width: 24rem;
  grid-column: 1 / 3;

  background: ${pickColor('orange')};
  color: ${pickColor('white')};
  text-align: center;

  border: 0;
  padding: 0.6rem;

  ${getFontScale('s')};
  font-weight: normal;
  line-height: 1;

  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const StyleTotalsLabel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  min-width: 0;

  ${getFontScale('xs')};
`;

const StyleTotalsLabelText = styled.span`
  color: ${pickColor('grayDark')};
  text-transform: capitalize;
`;

/* A large total wraps inside its fixed-width column, kept right-aligned */
const StyleTotalsValue = styled.span`
  max-width: 100%;

  font-weight: bold;
  color: ${pickColor('black')};
  text-align: right;
  overflow-wrap: anywhere;
`;

export {
  Body,
  ColoursContainer,
  DeliveryCell,
  DeliveryInput,
  DeliveryInputWrapper,
  DeliveryLabel,
  HeaderRow,
  ImageCell,
  InfoCell,
  PriceCell,
  PriceLabel,
  PriceValue,
  Section,
  StyleTotalsLabel,
  StyleTotalsLabelText,
  StyleTotalsRemoveCell,
  StyleTotalsRow,
  StyleTotalsValue,
  SubtitleLine,
  TitleLine,
};
